import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkqueueService } from '../../../BaseFramework/core/http/workqueue.service';


import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler

} from 'app'
import { AbstractControl, UntypedFormBuilder, FormControl, UntypedFormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';



@Component({
  selector: 'app-claims-workflow-audit',
  templateUrl: './claims-workflow-audit.component.html',
  styleUrls: ['./claims-workflow-audit.component.scss']
})
export class ClaimsWorkflowAuditComponent implements OnInit {
  _currentComponentName = 'ClaimsWorkflowAuditComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private workQueueService: WorkqueueService,
    public appMetadataHandler: AppMetadataHandler
  ) { }

  //Declaraions which might need developer input
  claimsWorkflowAuditForm: UntypedFormGroup
  CLAIMSWORKFLOWAUDITFORM = "claimsWorkflowAuditForm"
  selectorOfThisComponent = 'app-claims-workflow-audit'
  parentEvent$

  workFlowAudit: any = [];

  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() DO: any;
  @Input() transactionState: any;
  private _extractElementFromArray
  @Input()
  set ExtractElementFromArray(value) {
    this._extractElementFromArray = value
  }
  get ExtractElementFromArray() {
    return this._extractElementFromArray
  }
  @Input() maxDepth : number = 0

  private _IO = null;
  @Input()
  set IO(value: any) {
    if(value){
      this._IO = value;
      this.getWorkflowAudit(this._IO);
    }
  };

  get IO() {
    return this._IO;
  }

  getWorkflowAuditSubject$ = null
  getWorkflowAudit(IO) {
    if (IO != null) {
      let trnGuid = null;
      if(this.ExtractElementFromArray && this.commonUtilty.isArrayIterable(IO[this.DO])){
        trnGuid = IO[this.DO][this.maxDepth]? IO[this.DO][this.maxDepth]['guid'] : null;
      }
      else if(this.DO){
        trnGuid = IO[this.DO] ? IO[this.DO]['guid'] ? IO[this.DO]['guid'] : null : null;
      }
      else{
        let DO = this.commonUtilty.getDOName(IO);
        if(DO){ trnGuid = IO[DO] ? IO[DO]['guid'] ? IO[DO]['guid'] : null : null;}
        else trnGuid = IO['guid'] ? IO['guid'] : null;
      }
      if (trnGuid && trnGuid != null) {
        if (this.getWorkflowAuditSubject$) this.getWorkflowAuditSubject$.unsubscribe()
        //TODO check with Ninad about two parameters
        this.getWorkflowAuditSubject$ = this.workQueueService.getWorkflowAudit(trnGuid, null).subscribe(resp => {
          let taskDOList = resp;
          let corList
          if (IO && IO.correspondences)
            corList = IO.correspondences;

          // if (taskDOList && corList)
          //   this.workFlowAudit = [...taskDOList, ...corList];
          if (taskDOList)
            this.workFlowAudit = [...taskDOList];
          console.log(this.workFlowAudit)
          try {
            this.workFlowAudit = this.commonUtilty.sortDateObject('createdDt', this.workFlowAudit, 'desc')
          }
          catch{

          }
          this.workFlowAudit.forEach(item => {
            if (item && item.status) {
              switch (item.status.toLowerCase()) {
                case "completed": {
                  item.color = "green";
                  break;
                }
                case "pending": {
                  item.color = "orange";
                  break;
                }
                default: {
                  console.log("Invalid choice");
                  break;
                }
              }
            }
            else {
              item.color = "blue";
            }
          });
        },
          (error) => {
            throw " Something went wrong";
          }
        );
      }
    }
  }

  getClienNameByGuid(clientRefGuid) {
    let filterOutput = null;
    let output = {}
    let ownerRefGuid;
    let name = null;

    let clientDO = this._IO['clientDOs'];
    if (clientDO) {
      filterOutput = clientDO.find(item => {
        if (item)
          return item['guid'] === clientRefGuid;
      }) || []
    }
    if (filterOutput != null) {

      let firstName = this.commonUtilty.getFirstNameFromClient(filterOutput)
      let lastName = this.commonUtilty.getLastNameFromClient(filterOutput);
      if (firstName == null)
        firstName = '-'
      if (lastName == null)
        lastName = '-'
      output['name'] = (firstName || "") + " " + (lastName || ""),
        output['isAvailable'] = true;
    }
    else {
      output['name'] = '-';
      output['isAvailable'] = false;
    }
    return output;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component } catch { };
  }
  getParentComponentName(): string {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name } catch { };
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(null);
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }


  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }

    if (this.IO != null) this.initializeClientSearchForm(this.IO)
    this.subscribeToParentEvent()
  }

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.claimsWorkflowAuditForm = this.fb.group({

    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.CLAIMSWORKFLOWAUDITFORM
    }
    let returnObj = this.validationUtilService.isRequired(fieldName)
    return returnObj
  }


  getDateNowString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate, ['DD-MM-YYYY', 'X']).fromNow();
    }
    else {
      dateString = '-'
    }
    return dateString
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      // dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
      const momentFormat = this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR.replace('dd', 'DD').replace('yyyy', 'YYYY');
      dateString = moment(rawDate).format(momentFormat); 
    }
    else {
      dateString = '-'
    }
    return dateString
  }

  getDayDifference(startDt, endDt) {

    var start = moment(startDt, ['X']);
    var end = moment(endDt, ['X']);
    //end.from(start);       // "in 5 days"
    return end.from(start, true); // "5 days"
  }

  getHourDifference(startDt, endDt) {

    var start = moment(startDt, ['X']);
    var end = moment(endDt, ['X']);
    //end.from(start);       // "in 5 days"
    return end.from(start, true); // "5 days"

  }
}

